import { render, staticRenderFns } from "./DetailChartPanel.vue?vue&type=template&id=0ad38ced&scoped=true&"
import script from "./DetailChartPanel.vue?vue&type=script&lang=js&"
export * from "./DetailChartPanel.vue?vue&type=script&lang=js&"
import style0 from "./DetailChartPanel.vue?vue&type=style&index=0&lang=css&"
import style1 from "./DetailChartPanel.vue?vue&type=style&index=1&id=0ad38ced&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad38ced",
  null
  
)

export default component.exports